import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import css from './tab-list.css';

const TabList = ({ children, adjacent }) => (
  <ul
    role='tablist'
    className={classnames(css['ds-tab-list'], {
      [css['ds-tab-list--adjacent']]: adjacent,
    })}
  >
    {children}
  </ul>
);

TabList.defaultProps = {
  adjacent: false,
  children: null,
};

TabList.propTypes = {
  adjacent: PropTypes.bool,
  children: PropTypes.node,
};

export default TabList;
